import { render, staticRenderFns } from "./ModalProductImport.vue?vue&type=template&id=04fef620&scoped=true&"
import script from "./ModalProductImport.vue?vue&type=script&lang=js&"
export * from "./ModalProductImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fef620",
  null
  
)

export default component.exports